import { CatalogProductsIndex } from './CatalogProductsIndex';

export default CatalogProductsIndex;
